import { Spin } from 'antd';
export default () => {
  return <Spin style={{ position: 'fixed', left: '50%', top: '50%' }} />;
};
